module.exports = __webpack_public_path__ + "static/media/icon-down.0ddc6ebd.svg";